const set_city = (evt) => {
  // evt.preventDefault();
  const state = document.getElementById("state-selector").value;
  const city = document.getElementById("city-selector").value;

  localStorage.setItem("state", state);
  localStorage.setItem("city", city);

  // event.returnValue = true;
};

const get_geolocation = () => {
  const states = [
    ...document.getElementById("state-selector").querySelectorAll("option"),
  ]
    .map((ele) => (ele.disabled ? null : ele.textContent))
    .filter((ele) => ele);
  const cities = [
    ...document.getElementById("city-selector").querySelectorAll("option"),
  ].map((ele) => ele.value);

  console.log(states, cities);

  fetch("https://geolocation-db.com/json/")
    .then((res) => res.json())
    .then((res) => {
      if (states.includes(res.state) && cities.includes(res.city)) {
        document
          .getElementById("city-selector")
          .querySelector(`option[value=${res.city}]`)
          .setAttribute("selected", true);
      }
    });
};

const preventLink = (evt) => {
  if (
    evt.target.href &&
    evt.target.href.search(/(products|collections)\//) >= 0
  ) {
    if (!localStorage.getItem("state") || !localStorage.getItem("city"))
      evt.preventDefault();
    openModal("select-city-modal");
  }
};

window.addEventListener("DOMContentLoaded", () => {
  [...document.querySelectorAll("a")].map((ele) =>
    ele.addEventListener("click", preventLink)
  );

  get_geolocation();
});
